<template>
  <div class="container">
    <div id="courses" class="row">
      <div class="col-12 col-md-3">
        <div class="form-group">
          <label for="age-group">Age Rating:</label>
          <select v-model="minAgeInput" class="form-control" id="age-group">
            <option :value="0">0+ Years Old</option>
            <option :value="3">3+ Years Old</option>
            <option :value="5">5+ Years Old</option>
            <option :value="10">10+ Years Old</option>
            <option :value="13">13+ Years Old</option>
            <option :value="15">15+ Years Old</option>
            <option :value="18">18+ Years Old</option>
            <option :value="65">65+ Years Old</option>
          </select>
        </div>
        <div class="form-group">
          <label for="category">Category:</label>
          <select v-model="categoryInput" class="form-control" id="category">
            <option value="Animation">Animation</option>
            <option value="Creative Writing">Creative Writing</option>
            <option value="Film &amp; Video">Film &amp; Video</option>
            <option value="Fine Art">Fine Art</option>
            <option value="Graphic Design">Graphic Design</option>
            <option value="Illustration">Illustration</option>
            <option value="Music">Music</option>
            <option value="Photography">Photography</option>
            <option value="UI/UX Design">UI/UX Design</option>
            <option value="Web Development">Web Development</option>
            <option value="Business Analytics">Business Analytics</option>
            <option value="Freelance &amp; Entrepreneurship"
              >Freelance &amp; Entrepreneurship</option
            >
            <option value="Leadership &amp; Management"
              >Leadership &amp; Management</option
            >
            <option value="Marketing">Marketing</option>
            <option value="Lifestyle">Lifestyle</option>
            <option value="Productivity">Productivity</option>
          </select>
        </div>
      </div>
      <div class="col-12 col-md-9 ">
        <div class="form-group mb-4">
          <!-- <label for="search">Search</label> -->
          <input
            v-model="searchInput"
            type="text"
            class="form-control"
            id="search"
            placeholder="Search "
          />
        </div>
        <h3 v-if="filteredCourses.length === 0" class="text-center mt-3">
          No Courses Were Found Under Those Filters.
        </h3>
        <div class="row">
          <div
            v-for="course in filteredCourses"
            :key="course.id"
            class="col-12 col-md-6"
          >
            <div class="card">
              <img
                :src="
                  course.imgSrc ||
                    'https://www.gstatic.com/mobilesdk/180326_mobilesdk/discoverycards/experiments.png'
                "
                class="card-img-top"
                :alt="`${course.name}'s Cover Photo`"
              />
              <div class="card-body">
                <h5 class="card-title">
                  {{ course.name }} ({{ course.category.toUpperCase() }})
                </h5>
                <p class="card-text text-secondary">
                  {{ course.description }}
                </p>
              </div>
              <ul class="list-group list-group-flush">
                <li class="list-group-item text-primary">
                  Age Rating: {{ course.minAge }}+ years old
                </li>
                <li
                  v-for="meetTime in course.meetTimes"
                  :key="meetTime"
                  class="list-group-item"
                >
                  {{ meetTime }}
                </li>
              </ul>
              <div class="card-body">
                <router-link
                  :to="`/course/${course.id}`"
                  class="btn btn-block btn-primary"
                >
                  View Details
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import db from '@/components/firebaseInit'

export default {
  name: 'Courses',
  data() {
    return {
      courses: [],
      searchInput: '',
      minAgeInput: 0,
      categoryInput: 'Animation'
    }
  },
  computed: {
    filteredCourses() {
      return this.courses.filter(course => {
        const inName = course.name
          .toLowerCase()
          .includes(this.searchInput.toLowerCase())
        const inDescription = course.description
          .toLowerCase()
          .includes(this.searchInput.toLowerCase())
        const meetsAgeMin = course.minAge <= this.minAgeInput
        const categoryMatches = course.category === this.categoryInput
        return (inName || inDescription) && meetsAgeMin && categoryMatches
      })
    }
  },
  created() {
    db.collection('courses')
      .orderBy('name')
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc =>
          this.courses.push({ id: doc.id, ...doc.data() })
        )
      })
  }
}
</script>

<style lang="scss" scoped>
.container {
  padding: 30px 0;
}
.card {
  height: calc(100% - 30px);
  margin-bottom: 40px;
}
</style>
